import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPGoalsDatasource } from '../../global/datasources/ap_goals_datasource';

interface IStudentGoals {
  id: number;
  title: string;
  description: string;
  goal_type_name: string;
}
export class APGoalsQuery implements IQuery {
  private __result: Record<string, IStudentGoals[]>;

  constructor(QueryMediator: IQueryMediator, private ngAPGoalsDatasource: IAPGoalsDatasource) {
    QueryMediator.registerQuery(this, ngAPGoalsDatasource);
  }

  run(): this {
    const goalsData = this.ngAPGoalsDatasource.values();
    const goals: IStudentGoals[] = _4.map(goalsData, (goal) => {
      const { id, display_name: title, description, goal_type_name = 'Goal Type Name' } = goal;
      return {
        id,
        title,
        description: description || '',
        goal_type_name
      };
    });
    const _goalGroups = _4.groupBy(goals, 'goal_type_name');
    this.__result = _goalGroups;

    return this;
  }
  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPGoalsQuery', APGoalsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/queries/ap_goals_query.ts